import { render, staticRenderFns } from "./StatsType.vue?vue&type=template&id=4bdd1962&scoped=true&"
import script from "./StatsType.vue?vue&type=script&lang=js&"
export * from "./StatsType.vue?vue&type=script&lang=js&"
import style0 from "./StatsType.vue?vue&type=style&index=0&id=4bdd1962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd1962",
  null
  
)

export default component.exports